import React, { useEffect, useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { logDev } from "../utils/logger.js";
import { Snackbar, Alert } from "@mui/material";

const AnnulePaiement = () => {
  const { groupeId } = useParams();
  const [groupe, setGroupe] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/groupes/${groupeId}`)
      .then(res => {
        setGroupe(res.data);
        setLoading(false);
        logDev("⚠️ Paiement annulé, groupe chargé", res.data);
      })
      .catch(err => {
        logDev("❌ Erreur chargement groupe après annulation", { message: err.message });
        setLoading(false);
      });
  }, [groupeId]);

  const handleRetry = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/paiement/prolonger/${groupeId}`);
      setSnackbarOpen(true); 
      setTimeout(() => {
      window.location.href = res.data.url;
    }, 1000); // petit délai pour laisser le message apparaître
    } catch (err) {
      logDev("❌ Erreur relance Stripe", { message: err.message });
    }
  };

  if (loading) return <CircularProgress />;
  if (!groupe) return <Typography>Groupe introuvable</Typography>;

  return (
    <Box sx={{ maxWidth: 600, margin: "auto", mt: 4, p: 2, textAlign: "center" }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        😢 Paiement annulé
      </Typography>
      
      <Typography variant="h6" gutterBottom>
        {groupe.emoji || "🧩"} {groupe.nom}
      </Typography>
     
     <Typography sx={{ color: groupe.couleur || "#71685e", mb: 2 }}>
        Vous avez annulé le paiement. Ce groupe expirera bientôt si vous ne le prolongez pas.
      </Typography>
      
      <Button
        variant="contained"
        onClick={handleRetry}
        sx={{
          backgroundColor: groupe.couleur || "#71685e",
          color: "#fff",
          padding: "10px 20px",
          borderRadius: "6px",
          fontWeight: "bold"
        }}
      >
        🔁 Réessayer le paiement
      </Button>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >

    <Alert severity="success" sx={{ width: "100%" }}>
        ✅ Paiement relancé, redirection en cours…
    </Alert>
    </Snackbar>
    </Box>
  );
};

export default AnnulePaiement;
